import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

export type LottieProps = {
  animationJson: string | {};
  height?: number | string;
  width?: number | string;
  style?: { [key: string]: React.ReactText };
};

/**
 * Wrapper component for LottieFile's Player component
 * that allows user to simply pass an animation json file.
 * Note: has default param height and width of 200px.
 * animationJson parameter is a string of the raw animation
 * json content or JSON object
 */
const LottieAnimation = ({
  animationJson,
  height = 200,
  width = 200,
  style = {},
}: LottieProps): JSX.Element => {
  // allow for either raw string content or Path to file
  const animationSrc =
    typeof animationJson === 'string'
      ? animationJson
      : JSON.stringify(animationJson);

  return (
    <Player
      data-testid="lottie-animation"
      autoplay
      loop
      src={animationSrc}
      style={{
        height,
        width,
        ...style,
      }}
    />
  );
};

export default LottieAnimation;
